import { addToCart } from './cartStore.ts';

/** Couleur actuellement active dans un scope `[data-color-root]` (pastille sélectionnée,
 * ou seule couleur si le produit n'en a qu'une — pas de `.color-swatch` dans ce cas). */
export function getActiveColorId(scope: HTMLElement): string | undefined {
  return (
    scope.querySelector<HTMLElement>('.color-swatch.is-active')?.dataset.colorId ??
    scope.querySelector<HTMLElement>('[data-color-id]')?.dataset.colorId
  );
}

/** Câble le bouton "Ajouter au panier" des cartes produit (`.product-card`,
 * boutique + Bestsellers de la home) sur la couleur/taille actuellement
 * sélectionnées (voir `initColorSwitch`/`initSizeSelect` dans `client/productCard.ts`). */
export function initAddToCartButtons(): void {
  document.querySelectorAll<HTMLElement>('.product-card[data-product-id]').forEach((card) => {
    const button = card.querySelector<HTMLButtonElement>('.product-card__action--cart');
    if (!button) return;

    button.addEventListener('click', () => {
      const productId = card.dataset.productId;
      if (!productId) return;

      const colorId = getActiveColorId(card);
      if (!colorId) return;

      const sizesWrap = card.querySelector<HTMLElement>(`.product-card__sizes-wrap[data-color-id="${CSS.escape(colorId)}"]`);
      const selectedSize = sizesWrap?.querySelector<HTMLElement>('.product-card__size.is-selected');
      if (!selectedSize) return;

      const sizeEu = selectedSize.dataset.sizeEu;
      const stock = Number(selectedSize.dataset.stock ?? '0');
      if (!sizeEu || stock <= 0) return;

      addToCart({ productId, colorId, sizeEu, quantity: 1 }, stock);
    });
  });
}
